import { useEffect, useRef, useState } from 'react';
import './transcript-infographic.scss';
import { Media } from '../../../model/media.model';
import MediaService from '../../../services/media.service';
import { useSnackbar } from '../../../utility/snackbar.utility';
import CustomSnackbar from '../../snackbar/snackbar.component';
import CircularProgress from '@mui/material/CircularProgress';
import CHAT_ICON from "../../../assets/images/chat.svg";
import ICON_AI from "../../../assets/images/icon-ai.png";
import ChatTranscriptComponent from '../../detail/chat-transcript/chat-transcript.component';
import { SummaryContent } from '../../../model/summary-content.model';
import InfographicService from '../../../services/infographic.service';
import Button from '@mui/material/Button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const TranscriptInfographicComponent = ({ mediaId, infoId }) => {

    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();

    const summaryRef = useRef<HTMLDivElement | null>(null);

    const [loading, setLoading] = useState(true);
    const [summaryLoading, setSummaryLoading] = useState(true);
    const [media, setMedia] = useState<Media | null>(null);
    const [content, setContent] = useState<SummaryContent | null>(null);

    useEffect(() => {
        fetchMediaInfo();
    }, []);

    useEffect(() => {
        if (!content) {
            fetchSummary();
        }
    }, [content]);

    const fetchMediaInfo = async () => {
        try {
            setLoading(true);

            const mediaResponse = await MediaService.getMediaById(mediaId);
            setMedia(mediaResponse.data);

            const infoResponse = await InfographicService.getInfoById(mediaId, infoId);
            const summary = infoResponse.data.summary;
            setContent(summary)

            if (summary) {
                setSummaryLoading(false);
            }
        } catch (error) {
            showSnackbar('', 'error');
        } finally {
            setLoading(false);
        }
    };

    const fetchSummary = async () => {
        try {
            setSummaryLoading(true);
            const summaryResponse = await InfographicService.getSummary(mediaId, infoId);
            setContent(summaryResponse.data);
            setSummaryLoading(false);
        } catch (error) {
            showSnackbar('', 'error');
        }
    }

    const handleCopyText = () => {
        if (summaryRef.current) {
            const textToCopy = summaryRef.current.innerText;
            navigator.clipboard.writeText(textToCopy)
                .then(() => showSnackbar('ข้อความถูกคัดลอกแล้ว'))
                .catch(() => showSnackbar('เกิดข้อผิดพลาดในการคัดลอกข้อความ', 'error'));
        }
    }

    return (
        <>
            {
                loading ?
                    <div>
                        <CircularProgress />
                    </div> :
                    <div className='transcript-control'>
                        <div>
                            <div className="transcript-content-item-head-control mt-3">
                                <img src={CHAT_ICON} className="transcript-content-item-head-icon"></img>
                                <span className="transcript-content-item-head">เนื้อหาจากการถอดไฟล์เสียง</span>
                            </div>

                            <div className="transcript-content-item-border-control">
                                <div className="transcript-content-item-border-inside-control">
                                    {
                                        media?.transcripts && media?.transcripts.length > 0 &&
                                        <ChatTranscriptComponent transcriptList={media?.transcripts}></ChatTranscriptComponent>
                                    }

                                </div>
                            </div>
                        </div>

                        <div>
                            <div className='d-flex align-items-end justify-content-between mb-3'>
                                <div className="transcript-content-item-head-control mb-0">
                                    <img src={CHAT_ICON} className="transcript-content-item-head-icon"></img>
                                    <span className="transcript-content-item-head">เนื้อหาสรุปทั้งหมด</span>
                                </div>

                                <Button
                                    variant="outlined"
                                    className='summarize-info-button'
                                    startIcon={<img src={ICON_AI} className='me-1' width={20} height={19} />}
                                    onClick={() => fetchSummary()}
                                    disabled={summaryLoading}
                                >
                                    สรุปเนื้อหาใหม่อีกครั้ง
                                </Button>
                            </div>

                            <div className="transcript-content-item-border-control">
                                <div className="transcript-content-item-border-inside-control">
                                    {
                                        summaryLoading ?
                                            <div className="d-flex justify-content-center">
                                                <CircularProgress />
                                            </div> :
                                            content ?
                                                <div className="transcript-summarize-info-content">
                                                    <div className='d-flex justify-content-end mb-2'>
                                                        <Button
                                                            variant="text"
                                                            className="chat-copy-button"
                                                            startIcon={<ContentCopyIcon />}
                                                            onClick={handleCopyText}
                                                        >
                                                            คัดลอก
                                                        </Button>
                                                    </div>

                                                    <div ref={summaryRef}>
                                                        <p className="mb-2">{content.title}</p>

                                                        <p className="mb-2">{content.summarization}</p>

                                                        {
                                                            content.bullet_points.map((item, index) => (
                                                                <div key={index}>
                                                                    <p>{item.topic}</p>

                                                                    <ul className="mb-2">
                                                                        <li>{item.content}</li>
                                                                    </ul>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div> : <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )
}

export default TranscriptInfographicComponent;